if (!customElements.get('pill-switcher')) {
  class PillSwitcher extends HTMLElement {
    constructor() {
      super();

      this.container = this;
      this.section = this.container.closest('.section');
      this.sectionFootLinkEl = this.section.querySelector('.section__foot a');
      this.pills = this.container.querySelectorAll('.dynamic__pill');
      this.slider = this.section.querySelector('.card-slider.swiper');
      this.infinityLoadEl = this.slider.querySelector('infinity-load');
      this.cardProductClasses = this.slider.querySelector('card-product').className;
      this.isLoading = false;

      this.initActions();
    }

    initActions() {
      this.pills.forEach(pill => {
        pill.addEventListener('click', () => {
          this.container.querySelector('.dynamic__pill--active').classList.remove('dynamic__pill--active');
          pill.classList.add('dynamic__pill--active');

          this.fetchProducts(pill.dataset.collectionHandle);
        })
      })
    }
    async fetchProducts(collectionHandle) {
      if (this.isLoading) return;
      
      let url = `/collections/${collectionHandle}/?filter.v.availability=1&section_id=main-collection`;
      this.isLoading = true;
      
      try {
        fetch(url, {
          credentials: 'same-origin',
          method: 'GET'
        }).then((response) => {
          response.text().then((content) => {
            let tempElement = document.createElement('div');
            tempElement.innerHTML = content;

            let newProducts = tempElement.querySelectorAll('card-product');
            let productsContainer = this.section.querySelector('.card-slider__wrapper');
            // let markupProducts = ``;
            // let slidesPerGroup = newProducts.length > 6 ? 6 : newProducts.length;
            // let slide_index = 0;

            if(newProducts.length < 12){
              this.slider.setAttribute('data-swiper-options', JSON.stringify({
                "spaceBetweenDesktop": 0,
                "spaceBetweenMobile": 0,
                "slidesPerViewLaptop": 4,
                "slidesPerViewDesktop": 3,
                "slidesPerViewTablet": 3,
                "slidesPerViewMobile": 2,
                "inifiniteLoad": false
              }))

              this.infinityLoadEl.remove();
            }else{
              this.infinityLoadEl.setAttribute('data-collection-handle', collectionHandle);

              let newNextUrlElem = tempElement.querySelector('nav.pagination .pagination__prev-next--next') || undefined;

              newNextUrlElem 
              ? this.infinityLoadEl.querySelector('[data-next-url]').value = newNextUrlElem.getAttribute('href').replace(`/collections/${collectionHandle}`, '/')
              : this.infinityLoadEl.remove();
            }

            productsContainer.innerHTML = ``;
            productsContainer.appendChild(this.infinityLoadEl);
            this.sectionFootLinkEl && (this.sectionFootLinkEl.href = `/collections/${collectionHandle}`);

            newProducts.forEach(product => {
              product.className = this.cardProductClasses;
              productsContainer.insertAdjacentHTML('beforeend',`<div class="swiper-slide card-slider__slide card-slider__slide--group">${product.outerHTML}</div>` );
            });

            this.isLoading = false;
            this.section.classList.contains('loading-products') && this.section.classList.remove('loading-products');
            this.slider.dispatchEvent(new CustomEvent('dynamicCollection:changed'));
          })
        });
      } catch (error) {
        this.isLoading = false;
        console.error(error);
        alert(error.message);
      }
    }
  }

  customElements.define('pill-switcher', PillSwitcher);
}
